import React, { Suspense, useEffect } from "react";

import "./assets/css/style.css";

import { useAppDispatch, useAppSelector } from "./store/hooks";
import { fetchHistory } from "./store/picks/userPick-slice";
import { setActiveTab } from "./store/picks/tabs-slice";
import store from "./store/store";

import { useLoad } from "./hooks/useLoad";
import { useMuteAudio } from "./hooks/useMuteAudio";
import { useFetchConfig } from "./hooks/useFetchConfig";
import { useCheckOperatingSystem } from "./hooks/useCheckOperatingSystem";

import { ActiveTabEnum, GameTypeEnum } from "./enums";

import Header from "./components/Common/Header/Header";
import Footer from "./components/Common/Footer/Footer";
import BettingPanel from "./components/BettingPanel/BettingPanel";
import DrawingPanel from "./components/DrawingPanel/DrawingPanel";
import Loader from "./components/Common/Loader";
import ModalMessage from "./components/Common/ModalMessage/ModalMessage";
import AudioPlayer from "./components/Common/AudioPlayer/AudioPlayer";
import ShellWrapper from "./components/ShellWrapper/ShellWrapper";

const App: React.FC = () => {
  const { drawStarted, activeTab } = useAppSelector((state) => state.tab);
  const { gameType } = useAppSelector((state) => state.config);
  const { isBettingEnabled, isConnectionLost } = useFetchConfig();
  const { isLoading, message } = useLoad();
  const dispatch = useAppDispatch();

  useCheckOperatingSystem();
  useMuteAudio();

  useEffect(() => {
    if (drawStarted) {
      dispatch(setActiveTab(ActiveTabEnum.DRAW));
    }
  }, [dispatch, drawStarted]);

  useEffect(() => {
    if (!isLoading && gameType === GameTypeEnum.ONLINE) {
      dispatch(fetchHistory());
    }
  }, [dispatch, isLoading, gameType]);

  return (
    <Suspense fallback={<Loader message="error.loading" />}>
      {isLoading ? (
        <Loader message={message} />
      ) : (
        <>
          {gameType === GameTypeEnum.ONLINE && <Header />}

          {!isBettingEnabled && (
            <ModalMessage
              message={
                store.getState().config.isTicketTerminated
                  ? "message.ticketTerminated"
                  : "message.bettingDisabled"
              }
            />
          )}

          {isConnectionLost && gameType !== GameTypeEnum.PRESENTATION && (
            <ModalMessage message="message.connectionLost" />
          )}

          {isBettingEnabled && gameType === GameTypeEnum.ONLINE && (
            <AudioPlayer />
          )}

          {activeTab === ActiveTabEnum.DRAW && <DrawingPanel />}

          {activeTab === ActiveTabEnum.PLAY && <BettingPanel />}

          {activeTab === ActiveTabEnum.PLAY && <Footer />}

          {gameType !== GameTypeEnum.ONLINE && <ShellWrapper />}
        </>
      )}
    </Suspense>
  );
};

export default App;
